import { useState } from "react";
import { useTranslations } from "next-intl";
import AlgoliaRefinementList from "@components/search/algolia-refinement-list";
import DrawerSidebar from "@repo/ui/components/ui/drawer-sidebar";
import AlgoliaRangeInput from "@components/search/algolia-range-input";
import {
  useClearRefinements,
  useCurrentRefinements,
  useStats,
} from "react-instantsearch";
import AlgoliaSortBy from "@components/search/algolia-sort-by";
import { useAlgoliaSortBy } from "@/hooks/useAlgoliaSortBy";
import AlgoliaCurrentRefinements from "@components/search/algolia-current-refinements";
import AlgoliaHierarchicalMenu from "@components/search/algolia-hierarchical-menu";
import { useAlgoliaCategories } from "@components/search/hooks/useAlgoliaCategories";
import AlgoliaRefinementGender from "@components/search/algolia-refinement-gender";
import AlgoliaRefinementColor from "@components/search/algolia-refinement-color";

export default function AlgoliaFilters() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const t = useTranslations("Products-list.filters");
  const { refine: refineSortBy } = useAlgoliaSortBy();
  const { refine: clear } = useClearRefinements();
  const { nbHits } = useStats();
  const { canRefine } = useCurrentRefinements();
  const algoliaCategories = useAlgoliaCategories();

  const clearFilters = () => {
    clear();
    refineSortBy("products");
  };
  const submitFilters = () => setDrawerOpen(false);

  return (
    <DrawerSidebar
      labels={{
        trigger: t("filter_order"),
        title: t("filter_order"),
        clear: t("cancel"),
        submit: t("show"),
      }}
      actions={{
        clear: clearFilters,
        submit: submitFilters,
      }}
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
      itemsNumber={canRefine ? nbHits : 0}
    >
      <div className="p-10 pb-[100px] mt-10 flex flex-col">
        <section className="md:hidden">
          <AlgoliaCurrentRefinements />
        </section>
        <div className="">
          <AlgoliaSortBy title={t("order")} />
          <AlgoliaHierarchicalMenu
            attributes={algoliaCategories}
            title={t("category")}
          />
          <AlgoliaRefinementList
            searchable={true}
            title={t("brand")}
            placeholder={t("brand-placeholder")}
            attribute="brand"
            // sticky={true}
          />
          <AlgoliaRefinementList
            title={t("size")}
            attribute="size"
            customCheckbox={true}
          />
          <AlgoliaRefinementColor title={t("color")} />
          <AlgoliaRefinementGender title={t("gender")} />
          <AlgoliaRangeInput
            title={t("price")}
            attribute="minVariantTargetPrice"
          />
        </div>
      </div>
    </DrawerSidebar>
  );
}
